
























































































import {
  computed,
  defineComponent,
  reactive,
  Ref,
  ref,
} from "@vue/composition-api";
import { QBtn, QCard, QCardSection, QIcon, QTree } from "quasar";
import { Client } from "@/assets/js/constants";
import {
  deleteSessionClient,
  setSessionClient,
} from "@/data/repos/sessionSetClient";
import { getKV, setKV } from "@/modules/browserLocalStorage";
import { CLIENT_COOKIE_NAME } from "@/interfaces/common.interfaces";
import router from "@/router";
import { LoginResponse } from "@/data/repos/passwordLogin";
import {
  fetchUserInfo,
  getDayEnd,
  loginRedirect,
  SaveAuth,
} from "@/modules/auth";
import {
  getTerms,
  getTermsAgreed,
  setTermsAgreed,
  Term,
} from "@/data/repos/termsAndConditions";
import {
  checkLicense,
  redirectBackToTheClient,
  redirectToPreLogin,
} from "@/modules/utils";
import TermsDialog from "@/components/TermsDialog.vue";
import { getClients } from "@/data/repos/client";
import { Navbar } from "@micad/vue-components";
import Loading from "@/components/Loading.vue";
import config from "@/config";
import { checkSavedSession } from "@/data/repos/checkSavedSession";
import { Auth } from "@micad/vue-components/src/repos/login";
import Vue from "vue";
import { arrayToTree } from "@/modules/arrayToTree";
import { encryptAESBase64 } from "@/modules/crypto";

export default defineComponent({
  components: {
    TermsDialog,
    QBtn,
    Navbar,
    QCard,
    QCardSection,
    QIcon,
    Loading,
    QTree,
  },
  props: { session: String, clientKey: String, switch: Boolean },
  setup(p) {
    const session = reactive<LoginResponse>({} as LoginResponse);
    const query = router.currentRoute.query;
    const clients = ref<Client[]>([]);
    const clientKey = getKV(CLIENT_COOKIE_NAME);

    const maxClientsToDisplay = 10;
    const expandedNodes = ref<number[]>([]);
    const clientsForTree: Ref<Client[]> = computed<Client[]>(
      () => arrayToTree((clients.value || []) as Client[]) as Client[]
    );

    const clientsTree = ref();

    getSession();
    async function getSession() {
      // if session passed as a parameter
      if (p.session) Object.assign(session, JSON.parse(p.session));
      else {
        // if p.switch is true, unset client and get a new session
        // otherwise retrieve saved session and continue
        const ses = p.switch
          ? await getSessionWithClientKeyUnset()
          : await retrieveSession();
        Object.assign(session, ses);
        SaveAuth({
          userId: session.userId,
          sessionId: session.sessionId,
          expiry: session.expirationTimestamp || getDayEnd().toISOString(),
        } as Auth);
      }
      if (p.clientKey) {
        await selectClient({ key: p.clientKey } as Client);
      } else if (query.cid && query.cid.length) {
        await selectClient({ key: query.cid } as Client);
      } else {
        getClients({ includeChildren: true, hideInactive: true }).then(
          (data) => {
            if (data.ok) {
              if (data.payload) {
                clients.value = data.payload.sort((a, b) => {
                  if (a.key === clientKey) return -1;
                  if (b.key === clientKey) return 1;
                  return (a.name || a.key)
                    .toLowerCase()
                    .localeCompare((b.name || b.key).toLowerCase());
                });
                if (clients.value.length === 1) {
                  waitForUserInfo()
                    .then(() => selectClient(clients.value[0]))
                    .catch((e: Error) =>
                      Vue.$toast.error(e.message, { timeout: 60000 })
                    );
                  return;
                }
              }
              if (clients.value.length > maxClientsToDisplay) {
                expandedNodes.value = ((clients.value || []) as Client[])
                  .filter((c: Client) => !c.parentId)
                  .map((c: Client) => c.id);
              }
              state.loaded = true;
            } else {
              loginRedirect(router.currentRoute.query);
            }
          }
        );
      }
    }

    function myFilterMethod(node: Client, filter: string) {
      return (
        (node.name &&
          node.name.toLowerCase().indexOf(filter.toLowerCase()) > -1) ||
        (node.key && node.key.toLowerCase().indexOf(filter.toLowerCase()) > -1)
      );
    }

    const lastExpanded = ref([] as number[]);
    const lastExpandedIsSet = ref(false);

    function onClientSearch() {
      if (!!state.clientSearch) {
        if (!lastExpandedIsSet.value) {
          lastExpanded.value = [...expandedNodes.value];
          lastExpandedIsSet.value = true;
        }
        setTimeout(() => {
          clientsTree.value.expandAll();
        });
      } else {
        expandedNodes.value = [...lastExpanded.value];
      }
    }

    async function getSessionWithClientKeyUnset() {
      const sesResp = await deleteSessionClient();
      if (sesResp.ok) return sesResp.payload;
      else {
        redirectToPreLogin(query);
      }
    }
    async function retrieveSession() {
      const resp = await checkSavedSession();
      if (resp.ok && resp.payload) return resp.payload;
      else {
        redirectToPreLogin(query);
      }
    }

    async function selectClient(client: Client) {
      const resp = await setSessionClient(
        client.key,
        undefined,
        query.app as string | undefined
      );
      session.clientKey = client.key;
      if (!resp.ok && resp.response?.status === 403) {
        // MFA
        if (resp.response.data.errorMessage === "MFA") {
          session.errorMessage = resp.response.data.errorMessage;
          await router.push({
            name: "MFALogin",
            query: router.currentRoute.query,
            params: { session: JSON.stringify(session) },
          });
        } else if (resp.response.data.errorType === "password") {
          Vue.$toast.error(
            resp.response.data.errorMessage + ", please reset your password",
            { timeout: 300000 }
          );
          setTimeout(
            () =>
              router.push({
                name: "forgot-password",
                params: {
                  pClientKey: client.key,
                  pUserName: state.authUser.userName,
                  pCallbackUrl: String(query.callbackUrl || ""),
                  pReturnUrl: String(query.returnUrl || ""),
                },
              }),
            1000
          );
        } else if (resp.response.data.errorMessage === "User is inactive") {
          Vue.$toast.error("You are not allowed to login to this client");
        } else {
          Vue.$toast.error("Internal server error");
        }
      } else if (resp.ok) {
        if (!(await checkLicense(query))) return;
        setKV(CLIENT_COOKIE_NAME, client.key);
        if (await checkTermsAgreed(query.app)) await redirect(session);
      }
    }

    async function redirect(resp: LoginResponse) {
      // If there is valid callbackUrl - redirect to it passing all authentication info
      const callbackUrl = decodeURIComponent(
        String(router.currentRoute.query.callbackUrl || "")
      );
      const decryptedSessionId =
        query.state && query.nonce
          ? await encryptAESBase64(
              resp.sessionId,
              query.nonce as string,
              query.state as string
            )
          : resp.sessionId;
      if (query.oidc) {
        router
          .push({
            name: "OIDC",
            query: {
              oidc: query.oidc,
              session_id: decryptedSessionId,
              expiration: resp.expirationTimestamp || getDayEnd().toISOString(),
            },
          })
          .then();
      } else if (callbackUrl && callbackUrl != "/")
        redirectBackToTheClient(callbackUrl, {
          client_key: resp.clientKey,
          user_id: resp.userId,
          session_id: decryptedSessionId,
          state: query.state as string | undefined,
          expiration: resp.expirationTimestamp || getDayEnd().toISOString(),
          return_uri: (query.returnUrl || "/") as string,
          // login_token: response.loginToken,
        });
      // otherwise if returnUrl present redirect back to returnUrl
      else if (router.currentRoute.query.returnUrl)
        window.location.href = String(router.currentRoute.query.returnUrl);
      // in case if above two are false redirect to the DEFAULT_REDIRECT_URL if present in the config
      else if (config.DEFAULT_REDIRECT_URL)
        window.location.href = String(config.DEFAULT_REDIRECT_URL);
      // otherwise go to accounts index page
      else await router.push("/");
    }

    async function checkTermsAgreed(app: any): Promise<boolean> {
      if (!query.app) return true;
      const agreed = (await getTermsAgreed(app)).payload;
      if (!agreed!.termsAgreed) {
        const termsResp = await getTerms(query.app as string, true);
        if (termsResp.ok && termsResp.payload && termsResp.payload.length) {
          state.terms = termsResp.payload;
          state.showTermsDialog = true;
          return false;
        } else {
          state.showTermsDialog = false;
        }
      }
      return true;
    }

    async function agreeToTerms() {
      await setTermsAgreed(query.app as string);
      await redirect(session);
    }

    fetchUserInfo().then((us) => {
      state.authUser.userName = `${us.userName}`;
      if (state.clientKeyHint) {
        state.logoSrc = `${window.location.origin}/api/brandingImage?clientKey=${state.clientKeyHint}&kind=login&id=0`;
        state.orgLogoSrc = `${window.location.origin}/api/brandingImage?clientKey=${state.clientKeyHint}&kind=login&id=1`;
        state.clientLogoSrc = `${window.location.origin}/api/brandingImage?clientKey=${state.clientKeyHint}&kind=login&id=2`;
      }
    });

    function waitForUserInfo(interval = 300, timeout = 5000): Promise<string> {
      return new Promise((resolve, reject) => {
        let waitTime = 0;
        const checkChange = () => {
          if (state.authUser.userName) {
            resolve(state.authUser.userName);
          } else {
            waitTime += interval;
            if (waitTime > timeout) {
              return reject(Error("Server timeout"));
            }
            setTimeout(checkChange, interval);
          }
        };
        checkChange();
      });
    }

    const state = reactive({
      loaded: false,
      clients,
      locationSuggestions: false,
      maxClientsToDisplay: 999,
      clientSearch: "",
      terms: [] as Term[],
      showTermsDialog: false,
      logoSrc: require("@/assets/images/micad-logo_minimal.svg"),
      orgLogoSrc: "" as string | undefined,
      clientLogoSrc: "" as string | undefined,
      clientKeyHint: getKV(CLIENT_COOKIE_NAME),
      agreeToTerms,
      selectClient,
      clientsTree,
      expandedNodes,
      selectedNode: null,
      clientsForTree,
      myFilterMethod,
      onClientSearch,
      authUser: {
        userName: "",
        userRole: "",
      },
      userDropdownOptions: [
        {
          label: "Sign out",
          onClick: async () =>
            router.push({
              name: "Logout",
              query: { status: "UserLogout" },
            }),
        },
      ] as { label: string; onClick: () => void }[],
    });
    return state;
  },
});
